export const USER_SETTINGS_KEYS = {
  company: 'livable_cmpany_name',
  confirmation: 'livable_not_confirmed_account',
  emailConfirmed: 'livable_user_email_confirmed',
  phoneConfirmed: 'livable_user_phone_confirmed',
  userRole: 'livable_user_role',
  companyName: 'livable_admin_cmpany_name',
  companyId: 'livable_cmpany_id',
  mfaReminderDismissed: 'livable_mfa_reminder_dismissed'
};
export const MFA_SETTINGS_ANCHOR = 'two-factor-auth';
export const MFA_SETTINGS_PATH = "/profile-settings?tab=sign-in-details#".concat(MFA_SETTINGS_ANCHOR);
export const TEAM_MEMBER_ROLES_BY_NAMES = {
  NonSpecified: 'add_new_property_flow.non_specified',
  LivableSuperAdmin: 'add_new_property_flow.livable_super_admin',
  LivableAdmin: 'add_new_property_flow.livable_admin',
  PropertyManagerAccountHolder: 'add_new_property_flow.property_owner',
  PropertyManagerRegular: 'add_new_property_flow.property_manager_regular',
  PropertyOwner: 'add_new_property_flow.property_manager_account_holder',
  LeasingAgent: 'add_new_property_flow.leasing_agent',
  Resident: 'add_new_property_flow.resident'
};
export const USER_ROLES_BY_NAME = {
  NonSpecified: 'NonSpecified',
  LivableSuperAdmin: 'LivableSuperAdmin',
  LivableAdmin: 'LivableAdmin',
  PropertyManagerAccountHolder: 'PropertyManagerAccountHolder',
  PropertyManagerRegular: 'PropertyManagerRegular',
  PropertyOwner: 'PropertyOwner',
  LeasingAgent: 'LeasingAgent',
  Resident: 'Resident'
};

/**
 * The API's role policies, mirrored from Livable.Auth AuthPolicies. Gate a surface on the same
 * policy its endpoints carry: a UI gate built any wider can only render controls whose requests 403.
 */
export const PM_HOLDER_OR_HIGHER_ROLES = [USER_ROLES_BY_NAME.LivableSuperAdmin, USER_ROLES_BY_NAME.LivableAdmin, USER_ROLES_BY_NAME.PropertyManagerAccountHolder];
export const PM_REGULAR_OR_HIGHER_ROLES = [...PM_HOLDER_OR_HIGHER_ROLES, USER_ROLES_BY_NAME.PropertyManagerRegular];
export const isPmHolderOrHigher = role => PM_HOLDER_OR_HIGHER_ROLES.includes(role !== null && role !== void 0 ? role : '');
export const isPmRegularOrHigher = role => PM_REGULAR_OR_HIGHER_ROLES.includes(role !== null && role !== void 0 ? role : '');
export const USER_ROLES_TO_NAME = {
  NonSpecified: 'Non Specified',
  LivableSuperAdmin: 'Livable Super Admin',
  LivableAdmin: 'Livable Admin',
  PropertyManagerAccountHolder: 'Property Manager Account Holder',
  PropertyManagerRegular: 'Property Manager Regular',
  PropertyOwner: 'Property Owner',
  LeasingAgent: 'Leasing Agent',
  Resident: 'Resident'
};
export const HS_USER_KEYS = {
  email: 'livable_hs_email',
  token: 'livable_hs_token'
};